<div class="container-fluid my-4">
  <div style="display: flex; justify-content: space-between">
    <h5 class="mb-0">Store Pickup Location</h5>
    <button class="btn btn-primary" (click)="openModal(createModal)">
      Add New Location
    </button>
  </div>

  <ng-template #deleteModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Delete Pickup Location</h5>
      <button
        type="button"
        class="close"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to delete this pickup location?</p>
      <p class="text-muted mb-0">
        <strong>{{ locationToDelete?.name }}</strong>
      </p>
      <small class="text-muted">{{ locationToDelete?.address }}</small>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss('Cancel click')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-danger"
        (click)="deletePickupLocation(locationToDelete._id)"
      >
        Delete
      </button>
    </div>
  </ng-template>

  <ng-template #createModal let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">{{ modalTitle }}</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="d('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="pickupForm" (ngSubmit)="createPickupLocation()">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>Name</label>
            <input
              type="text"
              class="form-control"
              formControlName="name"
              placeholder="Name"
            />
            <div
              *ngIf="
                pickupForm.get('name').touched && pickupForm.get('name').invalid
              "
              class="text-danger"
            >
              Name is required
            </div>
          </div>
          <div class="form-group col-md-6">
            <label>Delivery Timing</label>
            <input
              type="text"
              class="form-control"
              formControlName="deliveryTiming"
              placeholder="Delivery Timing"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>Mobile</label>
            <ngx-intl-tel-input
              style="display: block; width: 100%"
              class="country_code"
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[
                SearchCountryField.Iso2,
                SearchCountryField.Name
              ]"
              [selectFirstCountry]="false"
              [selectedCountryISO]="CountryISO.India"
              [maxLength]="15"
              [phoneValidation]="true"
              [separateDialCode]="separateDialCode"
              [numberFormat]="PhoneNumberFormat.National"
              formControlName="mobile"
              name="mobile"
            >
            </ngx-intl-tel-input>
            <div
              *ngIf="
                pickupForm.get('mobile').touched &&
                pickupForm.get('mobile').invalid
              "
              class="text-danger"
            >
              Please enter a valid mobile number
            </div>
          </div>
          <div class="form-group col-md-6">
            <label>Is Default</label>
            <div class="form-check mt-3">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="isDefault"
              />
              <label class="form-check-label">Default</label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Address</label>
          <textarea
            class="form-control"
            formControlName="address"
            rows="1"
            readonly
            placeholder="Select location on map"
          ></textarea>
          <div
            *ngIf="
              pickupForm.get('address').touched &&
              pickupForm.get('address').invalid
            "
            class="text-danger"
          >
            Address is required
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Select Location on Map: </label>
          <div
            id="pickupLocationMap"
            style="width: 100%; height: 300px"
            class="border rounded"
          ></div>
          <small class="form-text text-muted">
            Click on the map or search for a location. You can also drag the
            marker.
          </small>
        </div>

        <!-- Hidden fields for lat/long since they are populated by map -->
        <input type="hidden" formControlName="latitude" />
        <input type="hidden" formControlName="longitude" />

        <div class="modal-footer">
          <button type="submit" class="btn btn-success">
            {{ saveButtonText }}
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="d('Close click')"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </ng-template>

  <div class="row mt-3">
    <div class="col-12 pl-0 pr-0">
      <div class="card">
        <div class="card-body" style="padding: 0px">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
                <th>Mobile</th>
                <!-- <th>Lat/Lng</th> -->
                <th>Default</th>
                <th>Delivery Timing</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of pickupLocations">
                <td>{{ loc.name }}</td>
                <td>{{ loc.address }}</td>
                <td>
                  <span *ngIf="loc.mobile?.startsWith('+')">{{
                    loc.mobile
                  }}</span>
                  <span *ngIf="!loc.mobile?.startsWith('+')"
                    >{{ loc.diallingCode }} {{ loc.mobile }}</span
                  >
                </td>
                <!-- <td>{{ loc.latitude }}, {{ loc.longitude }}</td> -->
                <td>
                  <span *ngIf="loc.isDefault" class="badge badge-success"
                    >Yes</span
                  >
                  <span *ngIf="!loc.isDefault" class="badge badge-secondary"
                    >No</span
                  >
                </td>
                <td>{{ loc.deliveryTiming }}</td>
                <td>
                  <a
                    href="javascript: void(0);"
                    class="link mr-2"
                    placement="top"
                    (click)="editPickupLocation(loc, createModal)"
                    ngbTooltip="Edit"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="javascript: void(0);"
                    class="link text-danger"
                    placement="top"
                    (click)="openDeleteModal(loc, deleteModal)"
                    ngbTooltip="Delete"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </tr>
              <tr *ngIf="pickupLocations.length === 0">
                <td colspan="5" class="text-center">No locations found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
